jQuery(function () {
document.addEventListener("DOMContentLoaded", function () {
    const mediaQuery = window.matchMedia("(min-width: 768px) and (max-width:1118px)");

    if (mediaQuery.matches) {
        setTimeout(() => {
            const pushboxes = document.querySelectorAll('.columnmarker .component-pushbox');
            let maxHeight = 0;
            pushboxes.forEach(pushbox => {
                const height = pushbox.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });

            pushboxes.forEach(pushbox => {
                pushbox.style.setProperty('height', maxHeight + 'px', 'important');
            });

        }, 700);
    }
});
jQuery(function () {
    $('.section.vspace-sm').each(function () {
        if ($(this).find('.promoComponentRedsign').length) {
            $(this).addClass('promoComponent');
        }
    });
    // Select all the promoComponent elements under .main_content
    const promoComponents = document.querySelectorAll('.main_content .promoComponent');
    if (promoComponents.length > 0) {
        // Get the last promoComponent
        const lastPromoComponent = promoComponents[promoComponents.length - 1];
        const lastPromoSection = lastPromoComponent.closest('.section');

        if (lastPromoSection) {
            lastPromoSection.classList.add('marginBottom_lastPromo');
        }
    }
    async function setAlignment() {
        await delay(1000);
        setbottomAlignment();
    }

    equal_height_cards();


    setAlignment();
    //equal_height_text_elements();
});
$(window).on('load', function () {

    async function setAlignment() {
        await delay(1000);
        setbottomAlignment();
    }
    equal_height_cards();


    setAlignment();
    //equal_height_text_elements();
});
$(window).resize(function () {
    async function setAlignment() {
        await delay(1000);
        setbottomAlignment();
    }
    equal_height_cards();


    setAlignment();
   //equal_height_text_elements();
});

function delay(ms) {
    return new Promise(resolve =>
        setTimeout(resolve, ms));
}

function equal_height_cards() {
    $(".gapincard").not('.gapinInfocard').find('.Promobox--SingleCard > .component-pushbox').height("unset");
    $('.Promobox--SingleCard').height("unset");
    if ($(window).width() > 767) {
        $(".gapincard").not('.gapinInfocard').each(function () {
            var maxHeight = 0;
            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                if ($(this).parent().hasClass("promofullWidthImage")) { } else {
                    var height = $(this).outerHeight(true);
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                }

            });
            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                $(this).height(maxHeight);
            });
        });
        $(".gapin-promolist").each(function () {
            var maxHeightpromo = 0;
            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                var height = $(this).outerHeight(true);
                if (height > maxHeightpromo) {
                    maxHeightpromo = height;
                }
            });

            $(this).find('.Promobox--SingleCard > .component-pushbox').each(function () {
                $(this).height(maxHeightpromo);

            });

        });

    }


}

function setbottomAlignment() {
    if ($(window).width() > 767) {
        $(".Promobox--SingleCard > .component-pushbox").each(function () {


            var $pushbox = $(this),
                totalHeight = $(this).outerHeight(true),
                contentHeight = 0,
                difference = 0;
            // Calculate content height
            $pushbox.find(".promocontent-div").children()
                .filter(function () {
                    return $(this).css("position") !== "absolute";
                }).each(function () {
                    contentHeight += $(this).outerHeight(true);

                });

            // Calculate difference
            difference = Math.ceil(totalHeight - contentHeight);

            if (contentHeight > 0 && difference > 0) {
                $(this).find(".pushbox-button").css("margin-top", difference);
                //    $(this).find(".js-align-bottom").css("margin-top", difference);
            }

        });
    }
}


function equal_height_text_elements() {
    // Reset the height of promo-heading, promo-desc, and promo-subheading
    $(".gapincard").not('.gapinInfocard').find('.Promobox--SingleCard .promo-heading, .Promobox--SingleCard .promo-desc, .Promobox--SingleCard .promo-subheading').css("height", "unset");


    if ($(window).width() > 767) {
        $(".gapincard").not('.gapinInfocard').each(function () {
            // Equal height for promo-heading
            var maxHeadingHeight = 0;
            //$(this).find('.Promobox--SingleCard .promo-heading').each(function () {
            //    var height = $(this).outerHeight(true);
            //    if (height > maxHeadingHeight) {
            //        maxHeadingHeight = height;
            //    }
            //});
            //$(this).find('.Promobox--SingleCard .promo-heading').each(function () {
            //    $(this).css("height", maxHeadingHeight);
            //});

            // Equal height for promo-desc
            var maxDescHeight = 0;
            $(this).find('.Promobox--SingleCard .promo-desc').each(function () {
                var height = $(this).outerHeight(true);
                if (height > maxDescHeight) {
                    maxDescHeight = height;
                }
            });
            $(this).find('.Promobox--SingleCard .promo-desc').each(function () {
                $(this).css("height", maxDescHeight);
            });

            // Equal height for promo-subheading
            var maxSubheadingHeight = 0;
            //$(this).find('.Promobox--SingleCard .promo-subheading').each(function () {
            //    var height = $(this).outerHeight(true);
            //    if (height > maxSubheadingHeight) {
            //        maxSubheadingHeight = height;
            //    }
            //});
            //$(this).find('.Promobox--SingleCard .promo-subheading').each(function () {
            //    $(this).css("height", maxSubheadingHeight);
            //});

            $(this).find('.CTA_button_primary').each(function () {
                var $current = $(this);
                var hasButtonInSiblings = $(this).siblings().find('.pushbox-button').length > 0;

                if (!hasButtonInSiblings) {
                    $current.find('.js-align-bottom').css("margin-top", "0");
                }
            });
        });
    }
}



jQuery(function () {
    $(document).on('keydown', function (event) {
        if (event.key === 'Enter' || event.keyCode === 13) {
            // Get the currently focused element
            var focusedElement = $(document.activeElement);
            focusedElement.click();

        }
    });
});



//updated html nntrcha code - final chalnara
jQuery(function () {
    $('.slider-container').each(function () {
        let $container = $(this);
        let $slider = $container.find('.slider-wrapper');
        let currentIndex = 0;
        let leftArrow = $container.find('.left-arrow');
        let rightArrow = $container.find('.right-arrow');
        let $dotsContainer = $container.find('.slider-dots-container');

        if ($slider.length) {

            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }

            let slidesToShow = getSlidesToShow();

            $slider.slick({
                infinite: false,
                slidesToShow: slidesToShow,
                slidesToScroll: 1,
                arrows: false,  // disable default arrows to use custom ones
                dots: false,    // we handle dots manually
                responsive: [
                    { breakpoint: 1118, settings: { slidesToShow: 2 } },
                    { breakpoint: 576, settings: { slidesToShow: 1 } }
                ]
            });

            generateCustomDots();

            function getSlidesToShow() {
                let width = $(window).width();
                if (width < 576) return 1;
                if (width < 1118) return 2;
                return 3;
            }

            function getMaxIndex() {
                let totalSlides = $slider.find('.slick-slide').not('.slick-cloned').length;
                let slidesToShow = getSlidesToShow();
                return totalSlides - slidesToShow;
            }

            function updateArrows() {
                let maxIndex = getMaxIndex();

                if (currentIndex <= 0) {
                    leftArrow.css('pointer-events', 'none');
                    leftArrow.find('path').attr('fill', '#E6E7E8');
                } else {
                    leftArrow.css('pointer-events', 'auto');
                    leftArrow.find('path').attr('fill', '#8E9093');
                }

                if (currentIndex >= maxIndex) {
                    rightArrow.css('pointer-events', 'none');
                    rightArrow.find('path').attr('fill', '#E6E7E8');
                } else {
                    rightArrow.css('pointer-events', 'auto');
                    rightArrow.find('path').attr('fill', '#8E9093');
                }
            }

            function generateCustomDots() {
                let totalSlides = $slider.find('.slick-slide').not('.slick-cloned').length;
                let dotsHtml = '<ul class="custom-dots">';
                for (let i = 0; i < totalSlides; i++) {
                    dotsHtml += `<li data-slide="${i}" class="${i === 0 ? 'active' : ''}"></li>`;
                }
                dotsHtml += '</ul>';
                $dotsContainer.html(dotsHtml);
            }

            function updateDotsFromVisibleSlides() {
                $dotsContainer.find('li').removeClass('active');

                $slider.find('.slick-slide[aria-hidden="false"]').each(function () {
                    let index = $(this).data('slick-index');
                    $dotsContainer.find(`li[data-slide="${index}"]`).addClass('active');
                });
            }

            $dotsContainer.off('click').on('click', 'li', function () {
                let slideIndex = $(this).data('slide');
                $slider.slick('slickGoTo', slideIndex);
            });

            $slider.on('afterChange', function (event, slick, currentSlide) {
                currentIndex = currentSlide;
                updateArrows();
                updateDotsFromVisibleSlides();
            });

            currentIndex = 0;
            updateArrows();
            updateDotsFromVisibleSlides();

            leftArrow.off('click').on('click', function () {
                if (currentIndex > 0) {
                    $slider.slick('slickPrev');
                }
            });

            rightArrow.off('click').on('click', function () {
                let maxIndex = getMaxIndex();
                if (currentIndex < maxIndex) {
                    $slider.slick('slickNext');
                }
            });

            $(window).on('resize', function () {
                setTimeout(() => {
                    currentIndex = $slider.slick('slickCurrentSlide');
                    updateArrows();
                    updateDotsFromVisibleSlides();
                }, 300);
            });
        }
    });
});


//updated height wala - chalnara code
jQuery(function () {
    function adjustPromoContentHeight() {
        $('.slick-slider').each(function () {
            let $slider = $(this);

            // Reset height of promo-content inside current slider
            $slider.find('.promo-content').height('auto');

            // Calculate max height within current slider
            let maxHeight = 0;
            $slider.find('.promo-content').each(function () {
                let contentHeight = $(this).outerHeight();
                if (contentHeight > maxHeight) {
                    maxHeight = contentHeight;
                }
            });

            // Set max height to all promo-content in this slider
            $slider.find('.promo-content').height(maxHeight);
        });
    }

    // Initial adjustment on document ready
    adjustPromoContentHeight();

    // Adjust on window resize
    $(window).on('resize', function () {
        adjustPromoContentHeight();
    });

    // Adjust after slick slider changes
    $('.slick-slider').on('afterChange', function () {
        adjustPromoContentHeight();
    });
});

// code commented for promobox big height applied on a link of cards

// jQuery(function () {
//     // Get all <a> tags under .promoComponentRedsign that have .promo-heading inside
//     const promoLinks = Array.from(document.querySelectorAll(".promoComponentRedsign a")).filter(a =>
//         a.querySelector(".promo-heading")
//     );

//     if (promoLinks.length === 0) return;

//     // First, clear inline height on all <a> to get natural height
//     promoLinks.forEach(a => a.style.height = 'auto');

//     // Find the max height among all
//     let maxHeight = Math.max(...promoLinks.map(a => a.offsetHeight));

//     // Apply the max height to all
//     promoLinks.forEach(a => a.style.height = maxHeight + 'px');
// });

});